import { createContext } from "react"
import { Outlet } from "react-router-dom"
import {
  TenantButtonCopy,
  TenantRouteCopy,
  TenantSectionCopy,
  TenantStatusCopy,
  TenantTextCopy,
} from "@hydrologiq/gql/graphql"

export enum Section {
  ASSETS = "assets",
  CUSTOMERS = "customers",
  SYSTEMS = "systems",
  DEPLOYMENTS = "projects",
  ORDERS = "orders",
  FILLING = "filling",
  ALERTS = "alerts",
  DASHBOARDS = "dashboards",
  PLANNER = "planner",
  CONNECTIONS = "connections",
}

export type DefaultSectionCopy = {
  type: Section
  name: string
  base: string
  routes: TenantRouteCopy[]
  buttons: TenantButtonCopy[]
  headings: TenantTextCopy[]
  statuses: TenantStatusCopy[]
}

// Backwards compatibility type for sections that use plain string mappings
export type CopyMapping = Record<string, string>

type ContextState = {
  copy?: TenantSectionCopy
  defaultCopy: DefaultSectionCopy
}

export const CopyContext = createContext<ContextState | undefined>(undefined)

export const CopyProvider = ({
  copy,
  defaultCopy,
  section,
  children,
}: {
  copy?: TenantSectionCopy
  defaultCopy?: DefaultSectionCopy
  section: Section
  children?: React.ReactNode
}) => {
  const fallbackDefault: DefaultSectionCopy = defaultCopy || {
    type: section,
    name: section.charAt(0).toUpperCase() + section.slice(1),
    base: section.toLowerCase(),
    routes: [],
    buttons: [],
    headings: [],
    statuses: [],
  }

  const value = {
    copy: copy,
    defaultCopy: fallbackDefault,
  }

  return <CopyContext.Provider value={value}>{children ? children : <Outlet />}</CopyContext.Provider>
}
